<template>
  <div>
    <!-- <el-tabs v-model="activeName" @tab-click="handleClick" v-if="level !== 'STORE'">
      <el-tab-pane label="绑定设备订单" name="0"></el-tab-pane>
      <el-tab-pane label="区域设备订单" name="1" v-if="level === 'AREA'"></el-tab-pane>
    </el-tabs> -->
    <com-order-search typeOfView="partner" @search="handleSearch"></com-order-search>
    <div class="mb-15px flex justify-end">
      <el-button type="primary" @click="handleExport" :disabled="isExporting" :loading="isExporting">导出</el-button>
    </div>
    <com-order-list typeOfView="partner" :default-params="defaultParams" ref="table"></com-order-list>
  </div>
</template>

<script>
import { partnerChargeOrderExport } from '@/api/partners'
import { downloadFile } from '@/utils/download'

export default {
  props: {
    code: {
      type: String,
      default: ''
    },
    level: {
      type: String,
      default: ''
    }
  },
  watch: {
    code: {
      handler(val) {
        console.log('code changed:', val)
        if (val) {
          this.defaultParams.partnerCode = val
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      defaultParams: {},
      activeName: '0',
      exportQuery: {},
      isExporting: false,
      searchColumn: [
        {
          label: '网点名称',
          prop: 'name',
          type: 'input'
        },
        {
          label: '绑定时间',
          prop: 'date',
          type: 'date'
        }
      ]
    }
  },
  methods: {
    handleClick() {
      if (this.activeName === '1') {
        this.defaultParams.areaPartnerCode = this.code
        delete this.defaultParams.partnerCode
        this.$refs.table.init()
        return
      }

      this.defaultParams.partnerCode = this.code
      delete this.defaultParams.areaPartnerCode
      this.$refs.table.init()
    },
    handleSearch(val) {
      this.exportQuery = { ...val }
      this.$refs.table.search(val)
    },
    handleExport() {
      if (!this.code) {
        this.$message.error('合伙人编码不能为空')
        return
      }

      // 防止重复点击
      if (this.isExporting) {
        this.$message.warning('正在导出中，请勿重复点击')
        return
      }

      this.isExporting = true
      this.$message.info('请稍等,正在导出...')

      const params = {
        partnerCode: this.code,
        ...this.exportQuery
      }

      partnerChargeOrderExport(params)
        .then((blob) => {
          downloadFile(blob, `充电订单_${new Date().getTime()}.xlsx`)
          this.$message.success('导出成功')
        })
        .catch((error) => {
          console.error('导出失败:', error)
        })
        .finally(() => {
          this.isExporting = false
        })
    }
  }
}
</script>

<style lang="scss" scoped></style>
